export default __webpack_public_path__ + "static/media/15.971993ae.png";